// extracted by mini-css-extract-plugin
module.exports = {"center":"NotFound_center__jD9bW","errorCode":"NotFound_errorCode__2W4Ky","errorDesc":"NotFound_errorDesc__1Q6iT"};